import { render } from "./BaseInputSkeleton.vue?vue&type=template&id=0768af5e&scoped=true&ts=true&lang=pug"
import script from "./BaseInputSkeleton.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseInputSkeleton.vue?vue&type=script&lang=ts&setup=true"

import "./BaseInputSkeleton.vue?vue&type=style&index=0&id=0768af5e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0768af5e"]])

export default __exports__